import { render, staticRenderFns } from "./captain_status.vue?vue&type=template&id=35f60965&scoped=true&"
import script from "./captain_status.vue?vue&type=script&lang=js&"
export * from "./captain_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f60965",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f60965')) {
      api.createRecord('35f60965', component.options)
    } else {
      api.reload('35f60965', component.options)
    }
    module.hot.accept("./captain_status.vue?vue&type=template&id=35f60965&scoped=true&", function () {
      api.rerender('35f60965', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/captain_status.vue"
export default component.exports